// pages/ContactsAndCompanyInfoEditing/components/CountryDropdown/index.js
import React, { useState, useRef, useEffect } from 'react';
import { countryCodes } from '../CountryCodeSelector/countryCodes';
import styles from './styles.module.scss';

const CountryDropdown = ({ 
  selectedCountry, 
  onCountrySelect, 
  placeholder = "Select a country",
  className = '',
  required = false,
  error = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);

  const filteredCountries = countryCodes.filter(country =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    country.code.includes(searchTerm)
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          triggerRef.current && !triggerRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCountrySelect = (country) => {
    onCountrySelect(country);
    setIsOpen(false);
    setSearchTerm('');
  };

  const displayText = selectedCountry 
    ? `${selectedCountry.flag} ${selectedCountry.name} (${selectedCountry.code})`
    : placeholder;

  return (
    <div className={`${styles.countryDropdown} ${className}`}>
      <button
        ref={triggerRef}
        type="button"
        className={`${styles.trigger} ${error ? styles.error : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className={styles.selectedText}>{displayText}</span>
        <span className={`${styles.arrow} ${isOpen ? styles.open : ''}`}>▼</span>
      </button>

      {isOpen && (
        <div ref={dropdownRef} className={styles.dropdown}>
          <div className={styles.searchContainer}>
            <input
              type="text"
              placeholder="Search country..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
              autoFocus
            />
          </div>
          
          <div className={styles.countryList}>
            {filteredCountries.length > 0 ? (
              filteredCountries.map((country) => (
                <div
                  key={country.code}
                  className={`${styles.countryOption} ${
                    selectedCountry?.code === country.code ? styles.selected : ''
                  }`}
                  onClick={() => handleCountrySelect(country)}
                >
                  <span className={styles.optionFlag}>{country.flag}</span>
                  <span className={styles.optionName}>{country.name}</span>
                  <span className={styles.optionCode}>{country.code}</span>
                </div>
              ))
            ) : (
              <div className={styles.noResults}>
                No countries found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountryDropdown;